import { render, staticRenderFns } from "./FactFulnessPage.vue?vue&type=template&id=e70c5e36&"
import script from "./FactFulnessPage.vue?vue&type=script&lang=js&"
export * from "./FactFulnessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports